const languages = {
  1: 'en',
  2: 'he',
  3: 'ru'
};

export const getLanguageById = (lang_id) => {
  return languages[lang_id];
};
